/*
 * @Author: Teemo Ding
 * @Date: 2022-04-19 11:40:31
 * @LastEditTime: 2023-04-14 15:22:52
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/report.ts
 */

export enum ITime {
  Days = 'Days',
  Weeks = 'Weeks',
  Months = 'Months',
}

export enum IDateRange {
  Custom = 'Custom',
  Today = 'Today',
  Yesterday = 'Yesterday',
  Last24Hours = 'Last24Hours',
  Last7Days = 'Last7Days',
  Last30Days = 'Last30Days',
  Last90Days = 'Last90Days',
  LastCalendarWeek = 'LastCalendarWeek',
  LastCalendarMonth = 'LastCalendarMonth',
  LastCalendarYear = 'LastCalendarYear',
  WeekToDate = 'WeekToDate',
  MonthToDate = 'MonthToDate',
  QuarterToDate = 'QuarterToDate',
  YearToDate = 'YearToDate',
  FirstQuarter = 'FirstQuarter',
  SecondQuarter = 'SecondQuarter',
  ThirdQuarter = 'ThirdQuarter',
  FourthQuarter = 'FourthQuarter',
}

export enum IOrderTime {
  OrderCreatedTime = 'OrderCreatedTime',
  OrderPaidTime = 'OrderPaidTime',
  RegistrationDate = 'RegistrationDate',
  ProductCreatedDate = 'ProductCreatedDate',
  OrderPaidDate = 'OrderPaidDate',
  ParcelCreatedDate = 'ParcelCreatedDate',
  GiftcardCreatedDate = 'GiftcardCreatedDate',
  SubscriptionCreatedDate = 'SubscriptionCreatedDate',
}

export enum IReportCurrencyType {
  ReportingCurrency = 'ReportingCurrency',
  TransactionNativeCurrency = 'TransactionNativeCurrency',
}

export enum ICategory {
  Null = 'Null',
  Order = 'Order',
  Payment = 'Payment',
  Parcel = 'Parcel',
  Promotion = 'Promotion',
  Customer = 'Customer',
  GiftCard = 'GiftCard',
  Product = 'Product',
  Inventory = 'Inventory',
  Page = 'Page',
  OrderLineItemsReport = 'OrderLineItems',
  SubscriptionBuy = 'SubscriptionBuy',
}

export enum IExportFormat {
  CSV = 'CSV',
  Excel = 'Excel',
}
export enum IExportType {
  File,
  Email,
}
